import React from "react";
import { Grid } from "@material-ui/core";

export default function LocationList(props) {

  const { locations } = props;
  console.log(locations, "loc")

  return (
    <Grid container spacing={5} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
      {locations && locations.map((loc) => (
        <Grid item lg={4} md={4} sm={6} xs={12}>
          <div className="location_item" style={{height:"180px", overflow:"auto"}}>
            {/* <span>{loc.branchLocation && loc.branchLocation.area && loc.branchLocation.area.name}</span> */}
            {/* Address key not available in backend, need to add it */}
            {/* <p> {loc.branchLocation && loc.branchLocation.area && loc.branchLocation.area.address ? loc.area.address : "N/A"}</p> */}
           <span>{loc.city}</span>
           <p>{loc.address}</p>
          </div>
        </Grid>
      ))}
    </Grid>
  );
}
